export default "/images/search-icon-black.png?7b3774ae73c157e62eea2a1157373de6";